export const emptyContentForm = {
  title: "",
  description: "",
  video_link: "",
  audio_links: "",
  image_links: "",
  resource_links: "",
};

export function lines(value = "") {
  return String(value)
    .split("\n")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function linksFromText(value = "") {
  return lines(value).map((line) => {
    const separator = line.indexOf("|");
    if (separator < 0) return { description: "", value: line };
    return {
      description: line.slice(0, separator).trim(),
      value: line.slice(separator + 1).trim(),
    };
  }).filter((link) => link.value);
}

export function toContentPayload(form) {
  return {
    title: form.title.trim(),
    description: form.description.trim() || null,
    video_link: form.video_link.trim() || null,
    audio_link: lines(form.audio_links),
    image_link: lines(form.image_links),
    note_link: linksFromText(form.resource_links),
    tag_ids: [],
  };
}

export function fromContent(note) {
  const media = note.media || {};
  return {
    title: note.title || "",
    description: note.description || "",
    video_link: note.video_link || "",
    audio_links: (media.audio || []).map((item) => item.audio_link).join("\n"),
    image_links: (media.images || []).map((item) => item.image_link).join("\n"),
    resource_links: (media.links || []).map((item) =>
      item.description ? `${item.description} | ${item.value}` : item.value
    ).join("\n"),
  };
}

